export default {
  walkIn: [0, 65],
  wave: [100, 144],
  point: [200, 272],
  waitingIn: [300, 314],
  waitingOut: [314, 300],
  waiting: [400, 439],
  highFive: [1000, 1065],
  tieIn: [2000, 2045],
  tieLoopA: [2100, 2146],
  tieLoopB: [2200, 2243],
  tieLoopC: [2300, 2330],
  tieOut: [2400, 2445],
  phoneIn: [4000, 4041],
  phoneOut: [4041, 4000],
  phoneLoopA: [4100, 4156],
  phoneLoopB: [4200, 4252],
  phoneLoopC: [4300, 4339],
  phoneLoopD: [4400, 4413],
  phoneLoopE: [4500, 4549],
  notepadIn: [5000, 5021],
  notepadOut: [5021, 5000],
  notepadLoopA: [5100, 5141],
  notepadLoopB: [5200, 5238],
  pointIn: [6000, 6041],
  pointOut: [6041, 6000],
  pointLoopA: [6100, 6127],
  pointLoopB: [6200, 6220],
  maglasIn: [7000, 7017],
  maglasOut: [7017, 7000],
  maglasLoopA: [7100, 7180],
  maglasLoopB: [7200, 7211],
  maglasLoopC: [7300, 7348],
  error: [9000, 9001]
}



// WEBPACK FOOTER //
// ./src/assets/bean-man/lib/frameComponents.js